import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { USERS_URL, USER_LOGIN_URL } from '../shared/constats/urls';
import { IUserLogin } from '../shared/interfaces/IUserLogin';
import { User } from '../shared/models/User';
import { concatMap, map, switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TankService } from './tank.service';
import { Tank } from '../shared/models/Tank';

const USER_KEY = 'User';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userSubject = new BehaviorSubject<User>(this.getUserFromLocalStorage());
  public userObservable: Observable<User>;
  tankId: string;

  constructor(private http: HttpClient, private toastrService: ToastrService, private router: Router, private tankService: TankService) {
    this.userObservable = this.userSubject.asObservable();

  }

  public get currentUser(): User {
    return this.userSubject.value;
  }

  login(userLogin: IUserLogin): Observable<User> {
    return this.http.post<User>(USER_LOGIN_URL, userLogin).pipe(
      switchMap((user) => {
        this.setUserToLocalStorage(user);

        if (user.role == 'superadmin') {
          return this.tankService.getAll().pipe(
            tap((tanks: Tank[]) => {
              if (tanks && tanks.length > 0) {
                const enabledTank = tanks.find((tank) => this.tankService.isWebAccessEnabled(tank));
                this.tankService.setCurrentTank(enabledTank || tanks[0]);
              }
            }),
            concatMap(() => of(user)) // Return the user after tanks are processed
          );
        } else {
          console.log("desde user service tanks: ", user.tankId);
          return this.tankService.getTankByUser(user.id, user.tankId).pipe(
            tap((tanks: Tank[]) => {
              if (tanks && tanks.length > 0) {
                const enabledTank = tanks.find((tank) => this.tankService.isWebAccessEnabled(tank));
                this.tankService.setCurrentTank(enabledTank || tanks[0]);
              }
            }),
            concatMap(() => of(user)) // Return the user after tanks are processed
          );
        }
      }),
      tap({
        next: (user) => {
          this.userSubject.next(user);
          //this.toastrService.success(`Bienvenido ${user.name}!`, 'Inicio de sesión exitoso');
        },
        error: (errorResponse) => {
          const message = errorResponse.error && errorResponse.error.message
            ? errorResponse.error.message
            : errorResponse.error || 'Fallo el Inicio de sesión';
          this.toastrService.error(message, 'Fallo el Inicio de sesión');
        },
      })
    );
  }



  logout() {
    this.userSubject.next(new User());
    localStorage.clear();
    this.tankService.destroySubscriptions();
    //this.router.navigate(['/login']);
    this.router.navigateByUrl('/').then(() => {
      window.location.reload();
    });
  }


  welcomelogout() {
    this.userSubject.next(new User());
    localStorage.clear();
  }

  private setUserToLocalStorage(user: User) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  private getUserFromLocalStorage(): User {
    const userJson = localStorage.getItem(USER_KEY);
    if (userJson) return JSON.parse(userJson) as User;
    return new User();
  }


  getAll(): Observable<User[]> {
    return this.http.get<User[]>(USERS_URL);
  }

  getUser(id: number): Observable<User> {
    return this.http.get<User>(USERS_URL + '/' + id);
  }

  saveUser(user: User): Observable<any> {
    return this.http.post(USERS_URL + '/create', user);
  }

  editUser(id: number, user: User): Observable<any> {
    return this.http.put(USERS_URL + '/' + id, user);
  }
  deleteUser(id: number): Observable<any> {
    return this.http.delete(USERS_URL + '/' + id);
  }

  getAllAdmins(tankId: number): Observable<User[]> {
    return this.http.get<User[]>(USERS_URL + '/admins/' + tankId);
  }

  getAlloperators(tankId: number): Observable<User[]> {
    return this.http.get<User[]>(USERS_URL + '/operators/' + tankId);
  }

  getOperatorsByTank(id: Number): Observable<User[]> {
    // console.log('esto es desde el service: ' + id)
    return this.http.get<User[]>(USERS_URL + '/operatorsByTank/' + id);
  }

  getUsersByTank(id: Number): Observable<User[]> {
    // console.log('esto es desde el service: ' + id)
    return this.http.get<User[]>(USERS_URL + '/getUsersByTank/' + id);
  }

  getUserByTankAndId(tankId: number, userId: number): Observable<User> {
    return this.http.get<User>(`${USERS_URL}/getUserByTankAndId/${tankId}/${userId}`);
  }
  getCurrentUser(): User {
    return this.getUserFromLocalStorage()
  }


  loggedIn() {
    const user = this.getUserFromLocalStorage();
    if (user && user.token) {
      return true;
    }
    return false;
  }
}








